"use strict";
Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.translationsNamespace = exports.defaultTranslations = void 0;
/* istanbul ignore file @preserve */ /**
 * DO NOT EDIT!
 * This file was autogenerated by npm script `localizations-codegen`.
 * Changes may cause incorrect behavior and will be lost when the file is regenerated.
 *
 * Run `npx localizations-codegen` to regenerate.
 */ const defaultTranslations = exports.defaultTranslations = {
    donation: 'Donation',
    donationLongDescription: 'Donation long description',
    expirationDate: 'Expiration date',
    iAgreeWithSavingOfMyPaymentCardDetails: 'I agree with saving of my payment card details.',
    iWouldLikeToDonate0To1: 'I would like to donate {0} to {1}.',
    loading: 'Loading',
    payment: 'Payment',
    safeAndTrustedPaymentMethods: 'Safe and trusted payment methods',
    unavailablePaymentOption: 'Unavailable payment option'
};
const translationsNamespace = exports.translationsNamespace = 'checkout-payment';
